<template>
  <div class="diagnosis-report" style="">
    <el-card class="box-card">
      <div class="report-section">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card>
              <div slot="header">
                <span>线上诊断报告</span>
              </div>
              <div style="display: flex;">
                <div style="width: 10%;">
                  <el-button size="small" type="primary" class="btns" @click="handleUpload('1')">点击上传</el-button>
                </div>
                <div style="width: 90%;" v-if="onlineFileList.length > 0">
                  <div class="scrollbar" ref="onlineFileListscrollbar">
                     <el-card>
                       <el-row :gutter="20">
                         <el-col :span="6" v-for="(file,index) in onlineFileList" :key="file.id">
                           <el-card style="margin-bottom: 10px;">
                             <el-row :gutter="20">
                               <el-col :span="4" style="padding-top: 17px;">
                                 <!-- <i :class="getFileIconClass(file.url)" class="file-icon"></i> -->
                                 <svg v-if="getFileIconClass(file.url) === 'pdf'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#e94c4c" stroke-width="4" stroke-linejoin="bevel"/><path d="M21 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M10 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M32 33V25H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 30H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 25H13.5C14.8807 25 16 26.1193 16 27.5V27.5C16 28.8807 14.8807 30 13.5 30H10" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 25H23C25.2091 25 27 26.7909 27 29V29C27 31.2091 25.2091 33 23 33H21" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'png'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 22C44 20.8954 43.1046 20 42 20C40.8954 20 40 20.8954 40 22H44ZM24 8C25.1046 8 26 7.10457 26 6C26 4.89543 25.1046 4 24 4V8ZM39 40H9V44H39V40ZM8 39V9H4V39H8ZM40 22V39H44V22H40ZM9 8H24V4H9V8ZM9 40C8.44772 40 8 39.5523 8 39H4C4 41.7614 6.23857 44 9 44V40ZM39 44C41.7614 44 44 41.7614 44 39H40C40 39.5523 39.5523 40 39 40V44ZM8 9C8 8.44772 8.44771 8 9 8V4C6.23858 4 4 6.23857 4 9H8Z" fill="#f04459"/><path d="M6 35L16.6931 25.198C17.4389 24.5143 18.5779 24.4953 19.3461 25.1538L32 36" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 31L32.7735 26.2265C33.4772 25.5228 34.5914 25.4436 35.3877 26.0408L42 31" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31.4142 9.58579C30.6332 8.80474 29.3668 8.80474 28.5858 9.58579C27.8047 10.3668 27.8047 11.6332 28.5858 12.4142L31.4142 9.58579ZM34 15L32.5858 16.4142C33.3668 17.1953 34.6332 17.1953 35.4142 16.4142L34 15ZM43.4142 8.41421C44.1953 7.63317 44.1953 6.36683 43.4142 5.58579C42.6332 4.80474 41.3668 4.80474 40.5858 5.58579L43.4142 8.41421ZM28.5858 12.4142L32.5858 16.4142L35.4142 13.5858L31.4142 9.58579L28.5858 12.4142ZM35.4142 16.4142L43.4142 8.41421L40.5858 5.58579L32.5858 13.5858L35.4142 16.4142Z" fill="#f04459"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'doc'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#f04459" stroke-width="4" stroke-linejoin="bevel"/><path d="M10 25V33" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M10 25H12C14.2091 25 16 26.7909 16 29V29C16 31.2091 14.2091 33 12 33H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><ellipse cx="24" cy="29" rx="3" ry="4" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 25H36C33.7909 25 32 26.7909 32 29V29C32 31.2091 33.7909 33 36 33H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'ppt'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 41H38V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 7H38V14" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 34.2432V44L10 38.6187V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 13.973V4L10 9.38125V13.973" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="14" width="40" height="20" rx="2" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M21 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M35 20V28" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 20H35H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19H13C14.6569 19 16 20.3431 16 22V22C16 23.6569 14.6569 25 13 25H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 19H24C25.6569 19 27 20.3431 27 22V22C27 23.6569 25.6569 25 24 25H21" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'xlsx'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15V6C8 4.89543 8.89543 4 10 4H38C39.1046 4 40 4.89543 40 6V42C40 43.1046 39.1046 44 38 44H10C8.89543 44 8 43.1046 8 42V33" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31 15H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 23H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 31H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="15" width="18" height="18" fill="#4a4a4a" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 21L16 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 21L10 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 42C36 42 38 31.5324 38 28C38 24.8379 38 20.1712 38 14H10C10 17.4423 10 22.109 10 28C10 31.4506 12 42 24 42Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/><path d="M4 8L10 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 8L38 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M4 27H10" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 27H38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M7 44L13 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M41 44L35 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M24 42V14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M14.9204 39.0407C17.0024 40.783 19.9244 41.9998 23.9999 41.9998C28.1112 41.9998 31.0487 40.7712 33.1341 39.0137" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 12.3333C32 7.73096 28.4183 4 24 4C19.5817 4 16 7.73096 16 12.3333V14H32V12.3333Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/></svg>
                                </el-col>
                               <el-col :span="20">
                                 <el-tooltip  effect="light" :content="file.name" placement="top">
                                   <p class="flashing-text two-lines" style="padding-left: 10px;font-weight: 900; height: 40px;">{{ file.name }}</p>
                                 </el-tooltip>
                                 <el-tooltip  effect="light" :content="formatDate(file.createTime)" placement="top">
                                   <p class="flashing-text" style="padding-left: 10px;font-weight: 900;">{{ formatDate(file.createTime) }}</p>
                                 </el-tooltip>
                                 <!-- <el-button style="margin-left: 10px;" size="small" type="primary" class="btns" @click="downloadFile(file.url)">下载文件</el-button> -->
                                 <div style="display: flex; justify-content: space-between;">
                                    <svg style="height: 50px;" @click="downloadFile(file.name,file.url)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9999 29.0001L12 17.0001L19.9999 17.0001L19.9999 6.00011L27.9999 6.00011L27.9999 17.0001L35.9999 17.0001L23.9999 29.0001Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M42 37L6 37" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                      <path d="M34 44H14" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                    </svg>
                                    <svg style="padding-top: 10px;" @click="deletFile(1,onlineFileList,index)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 11L40 11" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M18 5L30 5" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M12 17H36V40C36 41.6569 34.6569 43 33 43H15C13.3431 43 12 41.6569 12 40V17Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linejoin="bevel"/>
                                      <path d="M20 25L28 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M28 25L20 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                    </svg>
                                  </div>
                               </el-col>
                             </el-row>
                           </el-card>
                         </el-col>
                       </el-row>
                     </el-card>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="report-section">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card>
              <div slot="header">
                <span>线下诊断报告</span>
              </div>
              <div style="display: flex;">
                <div style="width: 10%;">
                  <el-button size="small" type="primary" class="btns" @click="handleUpload('2')">点击上传</el-button>
                </div>
                <div style="width: 25%;">
                  <el-button size="small" type="primary" class="btns" @click="handleEtie('3')">编辑</el-button>
                  <el-button size="small" type="primary" class="btns" @click="handleView('4')">查看</el-button>
                </div>
                <div style="width: 90%;" v-if="offlineFileList.length > 0">
                  <div class="scrollbar" ref="offlineFileListscrollbar">
                     <el-card>
                       <el-row :gutter="20">
                         <el-col :span="6" v-for="(file, index) in offlineFileList" :key="file.id">
                           <el-card style="margin-bottom: 10px;">
                             <el-row :gutter="20">
                               <el-col :span="4">
                                 <!-- <i :class="getFileIconClass(file.url)" class="file-icon"></i> -->
                                 <svg v-if="getFileIconClass(file.url) === 'pdf'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#e94c4c" stroke-width="4" stroke-linejoin="bevel"/><path d="M21 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M10 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M32 33V25H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 30H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 25H13.5C14.8807 25 16 26.1193 16 27.5V27.5C16 28.8807 14.8807 30 13.5 30H10" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 25H23C25.2091 25 27 26.7909 27 29V29C27 31.2091 25.2091 33 23 33H21" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'png'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 22C44 20.8954 43.1046 20 42 20C40.8954 20 40 20.8954 40 22H44ZM24 8C25.1046 8 26 7.10457 26 6C26 4.89543 25.1046 4 24 4V8ZM39 40H9V44H39V40ZM8 39V9H4V39H8ZM40 22V39H44V22H40ZM9 8H24V4H9V8ZM9 40C8.44772 40 8 39.5523 8 39H4C4 41.7614 6.23857 44 9 44V40ZM39 44C41.7614 44 44 41.7614 44 39H40C40 39.5523 39.5523 40 39 40V44ZM8 9C8 8.44772 8.44771 8 9 8V4C6.23858 4 4 6.23857 4 9H8Z" fill="#f04459"/><path d="M6 35L16.6931 25.198C17.4389 24.5143 18.5779 24.4953 19.3461 25.1538L32 36" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 31L32.7735 26.2265C33.4772 25.5228 34.5914 25.4436 35.3877 26.0408L42 31" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31.4142 9.58579C30.6332 8.80474 29.3668 8.80474 28.5858 9.58579C27.8047 10.3668 27.8047 11.6332 28.5858 12.4142L31.4142 9.58579ZM34 15L32.5858 16.4142C33.3668 17.1953 34.6332 17.1953 35.4142 16.4142L34 15ZM43.4142 8.41421C44.1953 7.63317 44.1953 6.36683 43.4142 5.58579C42.6332 4.80474 41.3668 4.80474 40.5858 5.58579L43.4142 8.41421ZM28.5858 12.4142L32.5858 16.4142L35.4142 13.5858L31.4142 9.58579L28.5858 12.4142ZM35.4142 16.4142L43.4142 8.41421L40.5858 5.58579L32.5858 13.5858L35.4142 16.4142Z" fill="#f04459"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'doc'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#f04459" stroke-width="4" stroke-linejoin="bevel"/><path d="M10 25V33" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M10 25H12C14.2091 25 16 26.7909 16 29V29C16 31.2091 14.2091 33 12 33H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><ellipse cx="24" cy="29" rx="3" ry="4" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 25H36C33.7909 25 32 26.7909 32 29V29C32 31.2091 33.7909 33 36 33H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'ppt'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 41H38V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 7H38V14" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 34.2432V44L10 38.6187V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 13.973V4L10 9.38125V13.973" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="14" width="40" height="20" rx="2" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M21 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M35 20V28" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 20H35H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19H13C14.6569 19 16 20.3431 16 22V22C16 23.6569 14.6569 25 13 25H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 19H24C25.6569 19 27 20.3431 27 22V22C27 23.6569 25.6569 25 24 25H21" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'xlsx'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15V6C8 4.89543 8.89543 4 10 4H38C39.1046 4 40 4.89543 40 6V42C40 43.1046 39.1046 44 38 44H10C8.89543 44 8 43.1046 8 42V33" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31 15H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 23H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 31H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="15" width="18" height="18" fill="#4a4a4a" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 21L16 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 21L10 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 42C36 42 38 31.5324 38 28C38 24.8379 38 20.1712 38 14H10C10 17.4423 10 22.109 10 28C10 31.4506 12 42 24 42Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/><path d="M4 8L10 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 8L38 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M4 27H10" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 27H38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M7 44L13 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M41 44L35 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M24 42V14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M14.9204 39.0407C17.0024 40.783 19.9244 41.9998 23.9999 41.9998C28.1112 41.9998 31.0487 40.7712 33.1341 39.0137" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 12.3333C32 7.73096 28.4183 4 24 4C19.5817 4 16 7.73096 16 12.3333V14H32V12.3333Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/></svg>
                               </el-col>
                               <el-col :span="20">
                                 <el-tooltip  effect="light" :content="file.name" placement="top">
                                   <p class="flashing-text two-lines" style="padding-left: 10px;font-weight: 900;height: 40px;">{{ file.name }}</p>
                                 </el-tooltip>
                                 <el-tooltip  effect="light" :content="formatDate(file.createTime)" placement="top">
                                   <p class="flashing-text" style="padding-left: 10px;font-weight: 900;">{{ formatDate(file.createTime) }}</p>
                                 </el-tooltip>
                                 <!-- <el-button style="margin-left: 10px;" size="small" type="primary" class="btns" @click="downloadFile(file.url)">下载文件</el-button> -->
                                 <div style="display: flex; justify-content: space-between;">
                                    <svg style="height: 50px;" @click="downloadFile(file.name,file.url)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9999 29.0001L12 17.0001L19.9999 17.0001L19.9999 6.00011L27.9999 6.00011L27.9999 17.0001L35.9999 17.0001L23.9999 29.0001Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M42 37L6 37" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                      <path d="M34 44H14" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                    </svg>
                                    <svg style="padding-top: 10px;" @click="deletFile(2,offlineFileList,index)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 11L40 11" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M18 5L30 5" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M12 17H36V40C36 41.6569 34.6569 43 33 43H15C13.3431 43 12 41.6569 12 40V17Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linejoin="bevel"/>
                                      <path d="M20 25L28 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M28 25L20 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                    </svg>
                                  </div>
                               </el-col>
                             </el-row>
                           </el-card>
                         </el-col>
                       </el-row>
                     </el-card>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 上课方案 -->
    <!-- <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>上课方案</span>
      </div>
      <el-input
        type="textarea"
        :rows="4"
        :autosize="{ minRows: 8, maxRows: 8 }"
        placeholder="请输入上课方案内容"
        show-word-limit
        maxlength="9999999"
        v-model="classPlan">
      </el-input>
    </el-card> -->


    <div class="report-section">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card>
              <div slot="header">
                <span>阶段性规划方案</span>
              </div>
              <div style="display: flex;">
                <div style="width: 10%;">
                  <el-button size="small" type="primary" class="btns" @click="handleUpload('3')">点击上传</el-button>
                </div>
                <div style="width: 90%;" v-if="classPlan.length > 0">
                  <div class="scrollbar" ref="classPlanscrollbar">
                     <el-card>
                       <el-row :gutter="20">
                         <el-col :span="6" v-for="(file,index) in classPlan" :key="file.id">
                           <el-card style="margin-bottom: 10px;">
                             <el-row :gutter="20">
                               <el-col :span="4" style="padding-top: 17px;">
                                 <!-- <i :class="getFileIconClass(file.url)" class="file-icon"></i> -->
                                 <svg v-if="getFileIconClass(file.url) === 'pdf'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#e94c4c" stroke-width="4" stroke-linejoin="bevel"/><path d="M21 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M10 25V33" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/><path d="M32 33V25H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 30H37" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 25H13.5C14.8807 25 16 26.1193 16 27.5V27.5C16 28.8807 14.8807 30 13.5 30H10" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 25H23C25.2091 25 27 26.7909 27 29V29C27 31.2091 25.2091 33 23 33H21" stroke="#e94c4c" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#e94c4c" stroke-width="4" stroke-linecap="square"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'png'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 22C44 20.8954 43.1046 20 42 20C40.8954 20 40 20.8954 40 22H44ZM24 8C25.1046 8 26 7.10457 26 6C26 4.89543 25.1046 4 24 4V8ZM39 40H9V44H39V40ZM8 39V9H4V39H8ZM40 22V39H44V22H40ZM9 8H24V4H9V8ZM9 40C8.44772 40 8 39.5523 8 39H4C4 41.7614 6.23857 44 9 44V40ZM39 44C41.7614 44 44 41.7614 44 39H40C40 39.5523 39.5523 40 39 40V44ZM8 9C8 8.44772 8.44771 8 9 8V4C6.23858 4 4 6.23857 4 9H8Z" fill="#f04459"/><path d="M6 35L16.6931 25.198C17.4389 24.5143 18.5779 24.4953 19.3461 25.1538L32 36" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 31L32.7735 26.2265C33.4772 25.5228 34.5914 25.4436 35.3877 26.0408L42 31" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31.4142 9.58579C30.6332 8.80474 29.3668 8.80474 28.5858 9.58579C27.8047 10.3668 27.8047 11.6332 28.5858 12.4142L31.4142 9.58579ZM34 15L32.5858 16.4142C33.3668 17.1953 34.6332 17.1953 35.4142 16.4142L34 15ZM43.4142 8.41421C44.1953 7.63317 44.1953 6.36683 43.4142 5.58579C42.6332 4.80474 41.3668 4.80474 40.5858 5.58579L43.4142 8.41421ZM28.5858 12.4142L32.5858 16.4142L35.4142 13.5858L31.4142 9.58579L28.5858 12.4142ZM35.4142 16.4142L43.4142 8.41421L40.5858 5.58579L32.5858 13.5858L35.4142 16.4142Z" fill="#f04459"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'doc'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 38V44H38V38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 20V14L30 4H10V20" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M28 4V14H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 12H20" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="20" width="40" height="18" rx="2" stroke="#f04459" stroke-width="4" stroke-linejoin="bevel"/><path d="M10 25V33" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M10 25H12C14.2091 25 16 26.7909 16 29V29C16 31.2091 14.2091 33 12 33H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><ellipse cx="24" cy="29" rx="3" ry="4" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M38 25H36C33.7909 25 32 26.7909 32 29V29C32 31.2091 33.7909 33 36 33H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'ppt'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 41H38V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 7H38V14" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 34.2432V44L10 38.6187V34" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M25 13.973V4L10 9.38125V13.973" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><rect x="4" y="14" width="40" height="20" rx="2" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M21 19V29" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M35 20V28" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 20H35H38" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 19H13C14.6569 19 16 20.3431 16 22V22C16 23.6569 14.6569 25 13 25H10" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M21 19H24C25.6569 19 27 20.3431 27 22V22C27 23.6569 25.6569 25 24 25H21" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else-if="getFileIconClass(file.url) === 'xlsx'" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15V6C8 4.89543 8.89543 4 10 4H38C39.1046 4 40 4.89543 40 6V42C40 43.1046 39.1046 44 38 44H10C8.89543 44 8 43.1046 8 42V33" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M31 15H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 23H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><path d="M28 31H34" stroke="#f04459" stroke-width="4" stroke-linecap="square"/><rect x="4" y="15" width="18" height="18" fill="#4a4a4a" stroke="#f04459" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M10 21L16 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M16 21L10 27" stroke="#ada8a8" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/></svg>
                                 <svg v-else width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 42C36 42 38 31.5324 38 28C38 24.8379 38 20.1712 38 14H10C10 17.4423 10 22.109 10 28C10 31.4506 12 42 24 42Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/><path d="M4 8L10 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 8L38 14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M4 27H10" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M44 27H38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M7 44L13 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M41 44L35 38" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M24 42V14" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M14.9204 39.0407C17.0024 40.783 19.9244 41.9998 23.9999 41.9998C28.1112 41.9998 31.0487 40.7712 33.1341 39.0137" stroke="#fa1f38" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M32 12.3333C32 7.73096 28.4183 4 24 4C19.5817 4 16 7.73096 16 12.3333V14H32V12.3333Z" fill="#fd3d54" stroke="#fa1f38" stroke-width="4" stroke-linejoin="bevel"/></svg>
                                </el-col>
                               <el-col :span="20">
                                 <el-tooltip  effect="light" :content="file.name" placement="top">
                                   <p class="flashing-text two-lines" style="padding-left: 10px;font-weight: 900; height: 40px;">{{ file.name }}</p>
                                 </el-tooltip>
                                 <el-tooltip  effect="light" :content="formatDate(file.createTime)" placement="top">
                                   <p class="flashing-text" style="padding-left: 10px;font-weight: 900;">{{ formatDate(file.createTime) }}</p>
                                 </el-tooltip>
                                 <!-- <el-button style="margin-left: 10px;" size="small" type="primary" class="btns" @click="downloadFile(file.url)">下载文件</el-button> -->
                                 <div style="display: flex; justify-content: space-between;">
                                    <svg style="height: 50px;" @click="downloadFile(file.name,file.url)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9999 29.0001L12 17.0001L19.9999 17.0001L19.9999 6.00011L27.9999 6.00011L27.9999 17.0001L35.9999 17.0001L23.9999 29.0001Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M42 37L6 37" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                      <path d="M34 44H14" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                                    </svg>
                                    <svg style="padding-top: 10px;" @click="deletFile(3,classPlan,index)" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 11L40 11" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M18 5L30 5" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M12 17H36V40C36 41.6569 34.6569 43 33 43H15C13.3431 43 12 41.6569 12 40V17Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linejoin="bevel"/>
                                      <path d="M20 25L28 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                      <path d="M28 25L20 33" stroke="#fcfff9" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                                    </svg>
                                  </div>
                               </el-col>
                             </el-row>
                           </el-card>
                         </el-col>
                       </el-row>
                     </el-card>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

    <!-- 规划详情 -->
    <!-- <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>规划详情</span>
      </div>
      <el-input
        type="textarea"
        :rows="4"
        :autosize="{ minRows: 8, maxRows: 8 }"
        show-word-limit
        maxlength="9999999"
        placeholder="请输入规划详情内容"
        v-model="planDetails">
      </el-input>
    </el-card> -->

    <el-card class="box-card">
      <div style="text-align: center; margin-top: 20px;">
        <el-button style="width: 100%; height: 50px; border-radius: 10px;" class="btns" size="small" type="primary" @click="submitForm">保存</el-button>
        <!-- <el-button class="btns" size="small" type="primary" @click="resetForm">取消</el-button> -->
      </div>
    </el-card>


    <Elupload
      v-if="isShowElupload"
      @handleEventElUpload="handleEventElUpload"
      @handleEventElUploadSubt="handleEventElUploadSubt"
      :Uploadtypes="Uploadtypes"
      :fileAllLists="fileAllLists"
    ></Elupload>


    <el-dialog  :visible="isgradeTypeLong" center :title="gradeTypeDeleted ? '查看' : '编辑'" modal-append-to-body append-to-body   :close-on-click-modal="false"  :close-on-press-escape="false" :before-close="isgradeTypeLongCloseDialog" width="60%" >
        <div @click="captureCanvas2D" style=" text-align: center; padding: 5px 10px;  border-radius: 50px;  color: #fff;  background: #40a9ff;    width: 50px; right: 22px;  position: absolute; color: #fff; top: 75px; font-size: 15px;">下载</div>
        <div id="dataList2d" :class="gradeTypeDeleted ? 'no-click' : ''">
            <div style="text-align: center; font-size: 18px; font-weight: 900; margin: 10px;">{{ gradeType === 1 ? '小学线下诊断' : '初高线下诊断' }}
              <!-- <div @click="captureCanvas2D" style="  padding: 5px 10px;  border-radius: 50px;  color: #fff;  background: #40a9ff;    width: 50px; right: 22px;  position: absolute; color: #fff; top: 75px; font-size: 15px;">下载</div> -->
            </div>
            <div style="margin: 10px;">记录者：用孩子原话客观记录，复述给家长，不要主观评断</div>
            <div style="margin: 10px;">开场语：</div>
            <div style="margin: 10px;">Hello呀{{studentData.realname}}，我这边规划师x老师，知道我是来干啥的吗？不用紧张，咱们今天不上课，就是聊聊天，妈妈怎么给你介绍我的？如果有不想说的 就告诉我 老师不会强求哈，但是告诉老师的信息要是真的不要给老师隐瞒哈。老师今天来是帮助你解决问题的，让你学习生活更快乐，让家里更和谐。</div>
            <div style="margin: 10px;">注意：以下诊断内容是通用版本，根据孩子具体情况心理特点要增删一些问题！</div>

            <div style="margin: 10px;">1对1孩子基本情况：</div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">1. 可不可以给老师做个自我介绍呀？</div>
              <div >
                <el-input  class="input1"   v-model="input1"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">2. 兴趣爱好有哪些呀？</div>
              <div >
                <el-input class="input2"    v-model="input2"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">3. 现在家里给你报的兴趣班有哪些给老师说说</div>
              <div >
                <el-input  class="input3"   v-model="input3"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">4. 有没有不喜欢的兴趣班，让老师帮你跟爸妈说取消掉</div>
              <div >
                <el-input  class="input4"   v-model="input4"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">5. 现在适应学校生活吗，最近有没有感觉到有压力，焦虑，失眠，做梦，白天昏昏沉沉， 晚上睡不好，吃饭没胃口，容易拉肚子，掉头发变多，考试紧张吗？（手心出汗，大脑空白，发冷，脸发烫，担心考不好，考场上就算分数了，考试时间够用吗？），容易感冒吗，有感觉抵抗力下降等等现象？</div>
              <div >
                <el-input   class="input5"  v-model="input5"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">6. 在学校好朋友多不多，有没有同学欺负你呀，感觉班里卷不卷，课间都喜欢做什么？有没有当班干部？</div>
              <div >
                <el-input class="input6"    v-model="input6"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">7.  学校的老师你喜不喜欢，有没有讨厌的老师，讨厌的课，讨厌的作业呀。</div>
              <div >
                <el-input class="input7"    v-model="input7"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">8. 感觉学不会的科目，让自己头疼的科目？计算正确率怎么样？读一段英语听听口语怎么样？写过的作文我看看。</div>
              <div >
                <el-input  class="input8"   v-model="input8"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">9. 如果后期跟你匹配对应的学科，老师上门上课，你对老师有什么要求？性格上，年龄上，性别上，讲课思维上，风格上想要什么样的老师？你之前补课喜欢的老师都是什么样的给我介绍介绍。</div>
              <div >
                <el-input  class="input9"   v-model="input9"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">10. 平常学校留的作业，你感觉多不多啊？能不能完成？正确率怎么样？晚上几点能睡觉，早上几点需要起床？回到家到睡觉前的安排给我说一下。</div>
              <div >
                <el-input class="input10"    v-model="input10"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">11. 各科学习成绩（班级最好高分和满分人数），学校的进度，教辅资料书，教材版本（规划老师拍照片，方便给后续上门学科老师备课用）ket/pet学过吗？</div>
              <div >
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">教材版本及成绩：</div>
                  <el-input  class="input11"   style="width: 100%;" placeholder="请输入内容" v-model="input11" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">语文：</div>
                  <el-input  class="inputCopy1"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy1" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">数学：</div>
                  <el-input class="inputCopy2"    style="width: 100%;" placeholder="请输入内容" v-model="inputCopy2" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">英语：</div>
                  <el-input class="inputCopy3"    style="width: 100%;" placeholder="请输入内容" v-model="inputCopy3" type="text"  maxlength="9999999" ></el-input>
                </div>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">12. 爸爸妈妈平时吵架吗？</div>
              <div >
                <el-input  class="input12"  v-model="input12"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">13. 爸妈平时打不打你呀，怎么打你呀？最近一次打你啥时候呀？家长是经常指责打压你吗？对你批评的多还是表扬的多？感觉家长强势吗？和爸爸妈妈共同语言多吗？一放学就催你写作业生活中各种催你吗？呆在家里感觉心烦吗？管你的学习多吗？唠叨多吗？（你要相信老师会让爸妈做出相应的改变，学习本来就是一件痛苦的事情，特别是你，现在我能理解到你有一些压力，爸爸妈妈有时候对学校里的事情还不太了解，因为年代不同了，你现在读的中学和他们当初读的已经不一样了，我来就是帮你把学习生活尽可能变的更快乐。）</div>
              <div >
                <el-input  class="input13"     v-model="input13"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">14. 我们一起探讨你需要提升的地方有哪些？如果安排学科老师上门帮你，各科需要先帮你提升哪些部分？</div>
              <div >
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">语文：</div>
                  <el-input   class="input14"  style="width: 100%;" placeholder="请输入内容" v-model="input14" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">数学：</div>
                  <el-input  class="inputCopy4"   style="width: 100%;" placeholder="请输入内容" v-model="inputCopy4" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">英语：</div>
                  <el-input  class="inputCopy5"   style="width: 100%;" placeholder="请输入内容" v-model="inputCopy5" type="text"  maxlength="9999999" ></el-input>
                </div>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">15. 安排首次课你最想听什么？</div>
              <div >
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">语文：</div>
                  <el-input  class="input15"  style="width: 100%;" placeholder="请输入内容" v-model="input15" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">数学：</div>
                  <el-input  class="inputCopy6"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy6" type="text"  maxlength="9999999" ></el-input>
                </div>
                <div style="margin: 10px; display: flex;">
                  <div style="width: 150px;padding-top: 10px;">英语：</div>
                  <el-input  class="inputCopy7"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy7" type="text"  maxlength="9999999" ></el-input>
                </div>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">16. 你最想要哪些奖励（钱，礼物，一顿饭，放假等等等等）？</div>
              <div >
                <el-input  class="input16"  v-model="input16"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>



            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">17. 你今天聊的开心吗？还有什么样补充的吗？你今天告诉我的信息有哪些不能透露给家长的？</div>
              <div >
                <el-input  class="input17"  v-model="input17"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">18. 家长倾诉内容记录</div>
              <div >
                <el-input  class="input18"   v-model="input18"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">19. 学习力课程方案</div>
              <div >
                <el-input  class="input19"   v-model="input19"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>


            <div style="margin: 10px;">
              <div style="font-weight: bold;margin-bottom: 6px;">20. 可排课时间</div>
              <div >
                <el-input class="input20"    v-model="input20"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
              </div>
            </div>

        </div>

        <div style="text-align: end; padding: 40px 10px 0px 0px;">
              <el-button  :disabled="gradeTypeDeleted"   style="" class="btns" size="small" type="primary" @click="submitForm1">保存</el-button>
              <el-button style="" class="btns" size="small" type="primary" @click="submitForm2">取消</el-button>
        </div>

    </el-dialog>



    <el-dialog :visible="isgradeTypeLong1" center :title="gradeTypeDeleted ? '查看' : '编辑'" modal-append-to-body append-to-body  :close-on-click-modal="false"  :close-on-press-escape="false" :before-close="isgradeTypeLongCloseDialog" width="60%" >
      <div @click="captureCanvas2D" style="  padding: 5px 10px;  border-radius: 50px;  color: #fff;  background: #40a9ff;  text-align: center; width: 50px; right: 22px;  position: absolute; color: #fff; top: 75px; font-size: 15px;">下载</div>
      <div id="dataList2d" :class="gradeTypeDeleted ? 'no-click' : ''">
        <div style="text-align: center; font-size: 18px; font-weight: 900; margin: 10px;">{{ gradeType === 1 ? '小学线下诊断' : '初高线下诊断' }}
            <!-- <div @click="captureCanvas2D" style="  padding: 5px 10px;  border-radius: 50px;  color: #fff;  background: #40a9ff;    width: 50px; right: 22px;  position: absolute; color: #fff; top: 75px; font-size: 15px;">下载</div> -->
        </div>
        <div style="margin: 10px;">记录者：用孩子原话客观记录，复述给家长，不要主观评断</div>
        <div style="margin: 10px;">开场语：</div>
        <div style="margin: 10px;">Hello呀{{studentData.realname}}，我这边规划师x老师，知道我是来干啥的吗？不用紧张，咱们今天不上课，就是聊聊天，妈妈怎么给你介绍我的？如果有不想说的 就告诉我 老师不会强求哈，但是告诉老师的信息要是真的不要给老师隐瞒哈。老师今天来是帮助你解决问题的，让你学习生活更快乐，让家里更和谐。</div>
        <div style="margin: 10px;">注意：以下诊断内容是通用版本，根据孩子具体情况心理特点要增删一些问题！</div>

        <div style="margin: 10px;">1对1孩子基本情况：</div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">1. 给老师做个自我介绍呀？什么星座，兴趣爱好有哪些呀？</div>
          <div  >
            <el-input class="input1"  v-model="input1"  style="width: 100%;"  type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">2. 现在适应学校生活吗，班级卷不卷，有午休吗？最近有没有感觉到有压力，焦虑，失眠，做梦，白天昏昏沉沉， 晚上睡不好，吃饭没胃口，容易拉肚子，掉头发变多，考试紧张吗？（手心出汗，大脑空白，发冷，脸发烫，担心考不好，考场上就算分数了，考试时间够用吗？），容易感冒，感觉抵抗力下降等等现象？</div>
          <div >
            <el-input class="input2"    v-model="input2"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">3. 在班里面人际关系你感觉怎么样？课间都喜欢做什么？</div>
          <div >
            <el-input class="input3"    v-model="input3"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">4. 现在有没有讨厌的科目，感觉学不会的科目，让自己头疼的科目？</div>
          <div >
            <el-input  class="input4"  v-model="input4"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">5. 学校老师你有没有讨厌的老师？老师负责任吗？</div>
          <div >
            <el-input  class="input5"  v-model="input5"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">6. 之前都哪些科补过课，补的都是什么样的课，效果感觉怎么样？感觉帮助大吗？补课老师负责任吗？能听明白吗？你感觉你和现在补课老师遇到的瓶颈有哪些？效果欠缺在哪？</div>
          <div >
            <el-input  class="input6"    v-model="input6"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">7. 如果后期跟你匹配对应的学科，老师上门上课，你对老师有什么要求？性格上，年龄上，性别上，讲课思维上，风格上想要什么样的老师？你之前补课喜欢的老师都是什么样的给我介绍介绍。</div>
          <div >
            <el-input  class="input7"    v-model="input7"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">8. 平常学校留的作业，你感觉多不多啊？能不能完成？正确率怎么样？晚上几点能睡觉，早上几点需要起床？回到家到睡觉前的安排给我说一下。</div>
          <div >
            <el-input  class="input8"    v-model="input8"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">9. 各科学习成绩（班级最高分和满分人数），学校的进度，教辅资料书，教材版本（规划老师拍照片，方便给后续上门学科老师备课用，初三学生需要询问地理生物小中考成绩）（或可填在后面语数英具体成绩处）英语ket、 pet</div>
          <div >
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">教材版本及成绩：</div>
              <el-input  class="input9"   style="width: 100%;" placeholder="请输入内容" v-model="input9" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">语文：</div>
              <el-input   class="inputCopy1"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy1" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">数学：</div>
              <el-input   class="inputCopy2"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy2" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">英语：</div>
              <el-input   class="inputCopy3"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy3" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">物理：</div>
              <el-input  class="inputCopy4"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy4" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">化学：</div>
              <el-input   class="inputCopy5" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy5" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">生物：</div>
              <el-input   class="inputCopy22" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy22" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">政治：</div>
              <el-input  class="inputCopy23"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy23" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">地理：</div>
              <el-input  class="inputCopy24"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy24" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">历史：</div>
              <el-input   class="inputCopy25" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy25" type="text"  maxlength="9999999" ></el-input>
            </div>


          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">10. 自己想去的高中或者大学是哪个呀？关于你升学家里人怎么想的？如果现在没有理想院校的话，不知道院校名字的话，咱们先定一个分数段的目标好不好？比如说我们争取上高中/上区重点/上市重点/上本科线/上一本线。</div>
          <div >
            <el-input    class="input10" v-model="input10"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">11. 爸爸妈妈平时吵架吗？爸爸妈妈会因为你学习的事情，你们之间会闹矛盾吗？教育观点一致吗？爸爸妈妈各自是什么样的教育观点？爸爸妈妈上次吵架是什么时候？你和他们吵架吗？</div>
          <div >
            <el-input  class="input11"  v-model="input11"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">12. 家长是经常指责打压你吗？对你批评的多还是表扬的多？感觉家长强势吗？和爸爸妈妈共同语言多吗？一放学就催你写作业生活中各种催你吗？呆在家里感觉心烦吗？管你的学习多吗？唠叨多吗？（你要相信老师会让爸妈做出相应的改变，学习本来就是一件痛苦的事情，特别是你，现在我能理解到你有一些压力，爸爸妈妈有时候对学校里的事情还不太了解，因为年代不同了，你现在读的中学和他们当初读的已经不一样了，我来就是帮你把学习生活尽可能变的更快乐。）</div>
          <div >
            <el-input   class="input12"  v-model="input12"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">13. 我们一起探讨你需要提升的地方有哪些？如果安排学科老师上门帮你，各科需要先帮你提升哪些部分？</div>
          <div >
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">语文：</div>
              <el-input  class="input13"  style="width: 100%;" placeholder="请输入内容" v-model="input13" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">数学：</div>
              <el-input class="inputCopy6"    style="width: 100%;" placeholder="请输入内容" v-model="inputCopy6" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">英语：</div>
              <el-input  class="inputCopy7"   style="width: 100%;" placeholder="请输入内容" v-model="inputCopy7" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">物理：</div>
              <el-input  class="inputCopy8"   style="width: 100%;" placeholder="请输入内容" v-model="inputCopy8" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">化学：</div>
              <el-input class="inputCopy9"    style="width: 100%;" placeholder="请输入内容" v-model="inputCopy9" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">生物：</div>
              <el-input class="inputCopy10"    style="width: 100%;" placeholder="请输入内容" v-model="inputCopy10" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">政治：</div>
              <el-input  class="inputCopy11"   style="width: 100%;" placeholder="请输入内容" v-model="inputCopy11" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">地理：</div>
              <el-input    class="inputCopy12" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy12" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">历史：</div>
              <el-input   class="inputCopy13"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy13" type="text"  maxlength="9999999" ></el-input>
            </div>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">14. 安排首次课你最想听什么？</div>
          <div >
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">语文：</div>
              <el-input   class="input14"  style="width: 100%;" placeholder="请输入内容" v-model="input14" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">数学：</div>
              <el-input    class="inputCopy14" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy14" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">英语：</div>
              <el-input   class="inputCopy15"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy15" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">物理：</div>
              <el-input   class="inputCopy16"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy16" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">化学：</div>
              <el-input   class="inputCopy17"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy17" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">生物：</div>
              <el-input   class="inputCopy18"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy18" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">政治：</div>
              <el-input    class="inputCopy19" style="width: 100%;" placeholder="请输入内容" v-model="inputCopy19" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">地理：</div>
              <el-input   class="inputCopy20"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy20" type="text"  maxlength="9999999" ></el-input>
            </div>
            <div style="margin: 10px; display: flex;">
              <div style="width: 150px;padding-top: 10px;">历史：</div>
              <el-input   class="inputCopy21"  style="width: 100%;" placeholder="请输入内容" v-model="inputCopy21" type="text"  maxlength="9999999" ></el-input>
            </div>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;font-weight: bold;">15. 你最想要哪些奖励（钱，礼物，一顿饭，放假等等等等）？想要父母不要的。</div>
          <div >
            <el-input  class="input15"   v-model="input15"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>



        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">16. 你今天聊的开心吗？还有什么样补充的吗？你今天告诉我的信息有哪些不能透露给家长的？</div>
          <div >
            <el-input  class="input16"   v-model="input16"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">17. 家长倾诉内容记录</div>
          <div >
            <el-input  class="input17"  v-model="input17"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">18. 文化课方案</div>
          <div >
            <el-input   class="input18"   v-model="input18"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">19. 学习力课程方案</div>
          <div >
            <el-input    class="input19" v-model="input19"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div style="margin: 10px;">
          <div style="font-weight: bold;margin-bottom: 6px;">20. 可排课时间</div>
          <div >
            <el-input    class="input20" v-model="input20"   type="textarea"  :autosize="{ minRows: 4, maxRows: 4 }"     maxlength="9999999"   placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>

      <div style="text-align: end; padding: 40px 10px 0px 0px;">
        <el-button   :disabled="gradeTypeDeleted"  style="" class="btns" size="small" type="primary" @click="submitForm1">保存</el-button>
        <el-button style="" class="btns" size="small" type="primary" @click="submitForm2">取消</el-button>
      </div>

      </el-dialog>


  </div>
</template>

<script>
import Elupload from "./Elupload.vue";
import loadingUtils from "../../../utils/loading";
import axios from "axios";
import apiBaseUrl from "../../../../config/api";
import { Loading } from 'element-ui';

export default {
  components: {
    Elupload,
  },
  props: {
    studentData: {
      type: Object,
      default: () => {}
    },
    studentGradeType: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      input1:'',
      input2:'',
      input3:'',
      input4:'',
      input5:'',
      input6:'',
      input7:'',
      input8:'',
      input9:'',
      input10:'',
      input11:'',
      input12:'',
      input13:'',
      input14:'',
      input15:'',
      input16:'',
      input17:'',
      input18:'',
      input19:'',
      input20:'',


      inputCopy1:'',
      inputCopy2:'',
      inputCopy3:'',
      inputCopy4:'',
      inputCopy5:'',
      inputCopy6:'',
      inputCopy7:'',
      inputCopy8:'',
      inputCopy9:'',
      inputCopy10:'',
      inputCopy11:'',
      inputCopy12:'',
      inputCopy13:'',
      inputCopy14:'',
      inputCopy15:'',
      inputCopy16:'',
      inputCopy17:'',
      inputCopy18:'',
      inputCopy19:'',
      inputCopy20:'',
      inputCopy21:'',
      inputCopy22:'',
      inputCopy23:'',
      inputCopy24:'',
      inputCopy25:'',



      isShowElupload: false,
      onlineFileList: [
        // 示例数据
        // {name: 'example1.jpg', url: 'example1.jpg',createTime: new Date()},
        // {name: 'example2.doc', url: 'example1.doc',createTime: new Date()},
        // {name: 'example1.pdf', url: 'example1.pdf',createTime: new Date()},
        // {name: 'example1.xlsx',url: 'example1.xlsx', createTime: new Date()},
        // {name: 'example1.ppt', url: 'example1.ppt',createTime: new Date()},
      ],
      offlineFileList: [
        // 示例数据
        // {name: 'example3.pdf', url: 'example1.pdf', createTime: new Date()},
        // {name: 'example4.docx', url: 'example1.docx', createTime: new Date()},
      ],
      classPlan: [], // 上课方案
      planDetails: '', // 规划详情

      fileAllLists: [],

      findInfoData:{},

      gradeType:'',
      gradeTypeDeleted: true,
      isgradeTypeLong: false,

      isgradeTypeLong1: false,

      showBtns: true,
      titleis:'线下诊断报告',
    };
  },


  mounted() {

    this.handlestudentDiagnosefindInfo()
    this.gradeType = this.studentGradeType


    console.log(1111111111)
  },

  methods: {
    captureCanvas2D() {
      const loadingObj = Loading.service({
        lock: true,
        text: '下载中请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      })

      this.showBtns = false
      const canvas2d = document.getElementById('dataList2d')
      canvas2d.style.padding = '20px'

      const textareaMap = new Map([
        ['input1', this.input1],
        ['input2', this.input2],
        ['input3', this.input3],
        ['input4', this.input4],
        ['input5', this.input5],
        ['input6', this.input6],
        ['input7', this.input7],
        ['input8', this.input8],
        ['input9', this.input9],
        ['input10', this.input10],
        ['input11', this.input11],
        ['input12', this.input12],
        ['input13', this.input13],
        ['input14', this.input14],
        ['input15', this.input15],
        ['input16', this.input16],
        ['input17', this.input17],
        ['input18', this.input18],
        ['input19', this.input19],
        ['input20', this.input20],
        ['inputCopy1', this.inputCopy1],
        ['inputCopy2', this.inputCopy2],
        ['inputCopy3', this.inputCopy3],
        ['inputCopy4', this.inputCopy4],
        ['inputCopy5', this.inputCopy5],
        ['inputCopy6', this.inputCopy6],
        ['inputCopy7', this.inputCopy7],
        ['inputCopy8', this.inputCopy8],
        ['inputCopy9', this.inputCopy9],
        ['inputCopy10', this.inputCopy10],
        ['inputCopy11', this.inputCopy11],
        ['inputCopy12', this.inputCopy12],
        ['inputCopy13', this.inputCopy13],
        ['inputCopy14', this.inputCopy14],
        ['inputCopy15', this.inputCopy15],
        ['inputCopy16', this.inputCopy16],
        ['inputCopy17', this.inputCopy17],
        ['inputCopy18', this.inputCopy18],
        ['inputCopy19', this.inputCopy19],
        ['inputCopy20', this.inputCopy20],
        ['inputCopy21', this.inputCopy21],
        ['inputCopy22', this.inputCopy22],
        ['inputCopy23', this.inputCopy23],
        ['inputCopy24', this.inputCopy24],
        ['inputCopy25', this.inputCopy25],
      ])

      this.$html2canvas(canvas2d, {
        useCORS: true,
        scrollY: 0,
        width: canvas2d.offsetWidth,
        height: canvas2d.scrollHeight + 250,
        onclone: (document) => {
          document.querySelectorAll('.el-textarea').forEach((textareaWrapper) => {
            const modelName = Array.from(textareaWrapper.classList)
              .find(cls => cls.startsWith('input'))

            if (modelName && textareaMap.has(modelName)) {
              const value = textareaMap.get(modelName)
              const textarea = textareaWrapper.querySelector('.el-textarea__inner')

              if (textarea) {
                const div = document.createElement('div')
                div.style.whiteSpace = 'pre-wrap'
                div.style.wordBreak = 'break-word'
                div.style.width = '100%'
                div.style.minHeight = textarea.offsetHeight + 'px'
                div.style.border = '1px solid #DCDFE6'
                div.style.borderRadius = '4px'
                div.style.padding = '5px 15px'
                div.style.lineHeight = '1.5'
                div.style.fontSize = '14px'
                div.style.fontFamily = 'Arial'
                div.style.color = '#606266'
                div.style.backgroundColor = '#FFFFFF'
                div.style.overflow = 'auto'
                div.style.boxSizing = 'border-box'

                div.textContent = value || ''

                textareaWrapper.replaceWith(div)
              }
            }
          })
        }
      }).then(canvas => {
        try {
          const imgData = canvas.toDataURL('image/jpeg', 1.0)
          const link = document.createElement('a')
          link.href = imgData
          link.download = this.titleis + '.jpg'
          link.click()

          canvas.remove()
          loadingObj.close()
          this.showBtns = true
          this.$message.success('下载成功')
        } catch (error) {
          console.error('下载失败:', error)
          this.$message.error('下载失败，请重试')
          loadingObj.close()
          this.showBtns = true
        }
      }).catch(error => {
        console.error('生成图片失败:', error)
        this.$message.error('生成图片失败，请重试')
        loadingObj.close()
        this.showBtns = true
      })
    },

    captureCanvas2D1(){

      let eleDevicePixelRatio =  window.screen.width * window.devicePixelRatio / document.documentElement.clientWidth
      let resultEle = Math.trunc(eleDevicePixelRatio * 10) / 10

      let isSrollWidth = resultEle === 1.4 ? 800 : resultEle === 1.1 ? 850 : resultEle === 0.9 ? 900 : resultEle === 0.8 ? 950 : resultEle === 1.7 ? 700 : 1000

      this.showBtns = false

      const loadingObj =  Loading.service({ lock: true,  text: '下载中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'})

      const canvas2d = document.getElementById('dataList2d')
      canvas2d.style.padding = '20px'

      const scrollHeight = 8000
      const scrollWidth = isSrollWidth

      const fullCanvas = document.createElement('canvas')
      fullCanvas.width = scrollWidth
      fullCanvas.height = scrollHeight
      const fullCtx = fullCanvas.getContext('2d')


      for (let y = 0; y < scrollHeight; y += fullCanvas.height) {
          for (let x = 0; x < scrollWidth; x += fullCanvas.width) {
            this.$html2canvas(canvas2d, {
              scrollX: x,
              scrollY: y,
              logging : false,
              width: fullCanvas.width,
              height: fullCanvas.height,
              useCORS: true,
            }).then((canvas) => {
              fullCtx.drawImage(canvas, 0, 0, fullCanvas.width, fullCanvas.height)
              setTimeout(() => {
                let imgData = fullCanvas.toDataURL('image/jpg')
                let link = document.createElement('a')
                link.href = imgData
                link.download = this.titleis + '.jpg'
                link.click()
                fullCanvas.remove()
                loadingObj.close()
                this.showBtns = true
              }, 3000)
            }).catch((err) => {
              this.$message.error('canvas绘制失败，请重新下载')
              loadingObj.close()
            })
          }
      }


    },

    handlestudentDiagnosefindInfo(){
      axios.post(`${apiBaseUrl}/studentDiagnose/findInfo`, { studentId:this.studentData.id }, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              let data = res.data.data

              this.findInfoData = data
              this.onlineFileList = data.onlineReport ? JSON.parse(data.onlineReport) : []
              this.offlineFileList = data.offlineReport ? JSON.parse(data.offlineReport) : []
              this.classPlan = data.classPrecept ? JSON.parse(data.classPrecept) : []
              this.planDetails = data.projectDetails ? data.projectDetails : ''


              let reportInfo = data.reportInfo ? data.reportInfo : '{}'


              if(reportInfo){
                let reportInfoData = JSON.parse(reportInfo)

                this.input1 = reportInfoData.input1 ? reportInfoData.input1 : ''
                this.input2 = reportInfoData.input2 ? reportInfoData.input2 : ''
                this.input3 = reportInfoData.input3 ? reportInfoData.input3 : ''
                this.input4 = reportInfoData.input4 ? reportInfoData.input4 : ''
                this.input5 = reportInfoData.input5 ? reportInfoData.input5 : ''
                this.input6 = reportInfoData.input6 ? reportInfoData.input6 : ''
                this.input7 = reportInfoData.input7 ? reportInfoData.input7 : ''
                this.input8 = reportInfoData.input8 ? reportInfoData.input8 : ''
                this.input9 = reportInfoData.input9 ? reportInfoData.input9 : ''
                this.input10 = reportInfoData.input10 ? reportInfoData.input10 : ''
                this.input11 = reportInfoData.input11 ? reportInfoData.input11 : ''
                this.input12 = reportInfoData.input12 ? reportInfoData.input12 : ''
                this.input13 = reportInfoData.input13 ? reportInfoData.input13 : ''
                this.input14 = reportInfoData.input14 ? reportInfoData.input14 : ''
                this.input15 = reportInfoData.input15 ? reportInfoData.input15 : ''
                this.input16 = reportInfoData.input16 ? reportInfoData.input16 : ''
                this.input17 = reportInfoData.input17 ? reportInfoData.input17 : ''
                this.input18 = reportInfoData.input18 ? reportInfoData.input18 : ''
                this.input19 = reportInfoData.input19 ? reportInfoData.input19 : ''
                this.input20 = reportInfoData.input20 ? reportInfoData.input20 : ''

                this.inputCopy1 = reportInfoData.inputCopy1 ? reportInfoData.inputCopy1 : ''
                this.inputCopy2 = reportInfoData.inputCopy2 ? reportInfoData.inputCopy2 : ''
                this.inputCopy3 = reportInfoData.inputCopy3 ? reportInfoData.inputCopy3 : ''
                this.inputCopy4 = reportInfoData.inputCopy4 ? reportInfoData.inputCopy4 : ''
                this.inputCopy5 = reportInfoData.inputCopy5 ? reportInfoData.inputCopy5 : ''
                this.inputCopy6 = reportInfoData.inputCopy6 ? reportInfoData.inputCopy6 : ''
                this.inputCopy7 = reportInfoData.inputCopy7 ? reportInfoData.inputCopy7 : ''
                this.inputCopy8 = reportInfoData.inputCopy8 ? reportInfoData.inputCopy8 : ''
                this.inputCopy9 = reportInfoData.inputCopy9 ? reportInfoData.inputCopy9 : ''
                this.inputCopy10 = reportInfoData.inputCopy10 ? reportInfoData.inputCopy10 : ''
                this.inputCopy11 = reportInfoData.inputCopy11 ? reportInfoData.inputCopy11 : ''
                this.inputCopy12 = reportInfoData.inputCopy12 ? reportInfoData.inputCopy12 : ''
                this.inputCopy13 = reportInfoData.inputCopy13 ? reportInfoData.inputCopy13 : ''
                this.inputCopy14 = reportInfoData.inputCopy14 ? reportInfoData.inputCopy14 : ''
                this.inputCopy15 = reportInfoData.inputCopy15 ? reportInfoData.inputCopy15 : ''
                this.inputCopy16 = reportInfoData.inputCopy16 ? reportInfoData.inputCopy16 : ''
                this.inputCopy17 = reportInfoData.inputCopy17 ? reportInfoData.inputCopy17 : ''
                this.inputCopy18 = reportInfoData.inputCopy18 ? reportInfoData.inputCopy18 : ''
                this.inputCopy19 = reportInfoData.inputCopy19 ? reportInfoData.inputCopy19 : ''
                this.inputCopy20 = reportInfoData.inputCopy20 ? reportInfoData.inputCopy20 : ''
                this.inputCopy21 = reportInfoData.inputCopy21 ? reportInfoData.inputCopy21 : ''
                this.inputCopy22 = reportInfoData.inputCopy22 ? reportInfoData.inputCopy22 : ''
                this.inputCopy23 = reportInfoData.inputCopy23 ? reportInfoData.inputCopy23 : ''
                this.inputCopy24 = reportInfoData.inputCopy24 ? reportInfoData.inputCopy24 : ''
                this.inputCopy25 = reportInfoData.inputCopy25 ? reportInfoData.inputCopy25 : ''



              }

              this.$message({ type: 'success', message: res.data.message })
          }else{
            this.$message({ type: 'error', message: res.data.message })
          }

        }).catch((error) => {
          this.$message({ type: 'error', message: error })
      })
    },

    deletFile(type,list,index){
      this.$confirm('确定要删除该文件吗？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning' }).then(() => {
        if (type === 1) {
            this.onlineFileList.splice(index, 1)
        }
        if (type === 2) {
            this.offlineFileList.splice(index, 1)
        }
        if (type === 3) {
            this.classPlan.splice(index, 1)
        }
         this.$message({   type: 'success',   message: '删除成功!' })
      }).catch(() => {
        this.$message({  type: 'info',  message: '已取消删除'  });
      })
    },
    submitForm(){

      let date = {
        id: this.findInfoData.id ? this.findInfoData.id : '',
        studentId: this.studentData.id ? this.studentData.id : '',
        onlineReport: JSON.stringify(this.onlineFileList),
        offlineReport: JSON.stringify(this.offlineFileList),
        classPrecept: JSON.stringify(this.classPlan),
        projectDetails: this.planDetails ? this.planDetails : '',
      }

      axios.post(`${apiBaseUrl}/studentDiagnose/addOrUpdate`, date, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              this.$message({ type: 'success', message: '添加成功!' })
              this.$emit('handleEventBtns')
              this.handlestudentDiagnosefindInfo()
          }else{
            this.$message({ type: 'error', message: '添加失败' })
          }

        }).catch((error) => {
          this.$message({ type: 'error', message: error })
      })

    },
    resetForm(){
      this.$emit('handleEventBtns')
    },

    handleUpload(type) {
      this.Uploadtypes = type
      this.fileAllLists = []

      if (type === "1" ) {

      }

      if (type === "2") {

      }

      this.isShowElupload = true
    },

    handleEventElUpload(flileList) {
      this.isShowElupload = false;
    },


    submitForm1(){

      let JsonStringObj = {
        input1: this.input1,
        input2: this.input2,
        input3: this.input3,
        input4: this.input4,
        input5: this.input5,
        input6: this.input6,
        input7: this.input7,
        input8: this.input8,
        input9: this.input9,
        input10: this.input10,
        input11: this.input11,
        input12: this.input12,
        input13: this.input13,
        input14: this.input14,
        input15: this.input15,
        input16: this.input16,
        input17: this.input17,
        input18: this.input18,
        input19: this.input19,
        input20: this.input20,
        inputCopy1: this.inputCopy1,
        inputCopy2: this.inputCopy2,
        inputCopy3: this.inputCopy3,
        inputCopy4: this.inputCopy4,
        inputCopy5: this.inputCopy5,
        inputCopy6: this.inputCopy6,
        inputCopy7: this.inputCopy7,
        inputCopy8: this.inputCopy8,
        inputCopy9: this.inputCopy9,
        inputCopy10: this.inputCopy10,
        inputCopy11: this.inputCopy11,
        inputCopy12: this.inputCopy12,
        inputCopy13: this.inputCopy13,
        inputCopy14: this.inputCopy14,
        inputCopy15: this.inputCopy15,
        inputCopy16: this.inputCopy16,
        inputCopy17: this.inputCopy17,
        inputCopy18: this.inputCopy18,
        inputCopy19: this.inputCopy19,
        inputCopy20: this.inputCopy20,
        inputCopy21: this.inputCopy21,
        inputCopy22: this.inputCopy22,
        inputCopy23: this.inputCopy23,
        inputCopy24: this.inputCopy24,
        inputCopy25: this.inputCopy25,
      }

      let date = {
        id: this.findInfoData.id ? this.findInfoData.id : '',
        studentId:  this.studentData.id ? this.studentData.id  : '',
        onlineReport: JSON.stringify([]),
        offlineReport: JSON.stringify([]),
        classPrecept: '',
        projectDetails: '',
        reportInfo: JSON.stringify(JsonStringObj),
      }

      axios.post(`${apiBaseUrl}/studentDiagnose/addOrUpdate`, date, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              this.$message({ type: 'success', message: '添加成功!' })
              this.submitForm2()
              this.handlestudentDiagnosefindInfo()
          }else{
            this.$message({ type: 'error', message: '添加失败' })
          }
        }).catch((error) => {
          this.$message({ type: 'error', message: error })
      })

    },
    submitForm2(){

      this.gradeTypeDeleted = false
      this.isgradeTypeLong = false
      this.isgradeTypeLong1 = false

      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.input4 = ''
      this.input5 = ''
      this.input6 = ''
      this.input7 = ''
      this.input8 = ''
      this.input9 = ''
      this.input10 = ''
      this.input11 = ''
      this.input12 = ''
      this.input13 = ''
      this.input14 = ''
      this.input15 = ''
      this.input16 = ''
      this.input17 = ''
      this.input18 = ''
      this.input19 = ''
      this.input20 = ''

      this.inputCopy1 = ''
      this.inputCopy2 = ''
      this.inputCopy3 = ''
      this.inputCopy4 = ''
      this.inputCopy5 = ''
      this.inputCopy6 = ''
      this.inputCopy7 = ''
      this.inputCopy8 = ''
      this.inputCopy9 = ''
      this.inputCopy10 = ''
      this.inputCopy11 = ''
      this.inputCopy12 = ''
      this.inputCopy13 = ''
      this.inputCopy14 = ''
      this.inputCopy15 = ''
      this.inputCopy16 = ''
      this.inputCopy17 = ''
      this.inputCopy18 = ''
      this.inputCopy19 = ''
      this.inputCopy20 = ''
      this.inputCopy21 = ''
      this.inputCopy22 = ''
      this.inputCopy23 = ''
      this.inputCopy24 = ''
      this.inputCopy25 = ''

    },

    handleEtie() {
     if(this.gradeType === 1){
       this.isgradeTypeLong = true
     }
     if(this.gradeType === 2){
       this.isgradeTypeLong1 = true
     }

     this.gradeTypeDeleted = false
    },
    handleView() {
      this.gradeTypeDeleted = true

      if(this.gradeType === 1){
        this.isgradeTypeLong = true
      }
      if(this.gradeType === 2){
        this.isgradeTypeLong1 = true
      }
    },

    isgradeTypeLongCloseDialog(){
      this.gradeTypeDeleted = false
      this.isgradeTypeLong = false
      this.isgradeTypeLong1 = false
    },

    setonlineFileListScrollbarHeight() {
      const scrollbar = this.$refs.onlineFileListscrollbar;
      if (scrollbar) {
        if (this.onlineFileList.length > 12) {
          scrollbar.style.height = '800px';
        } else if (this.onlineFileList.length > 8) {
          scrollbar.style.height = '500px';
        } else {
          scrollbar.style.height = '300px';
        }
      }
    },

    setofflineFileListScrollbarHeight() {
      const scrollbar = this.$refs.offlineFileListscrollbar;
      if (scrollbar) {
        if (this.onlineFileList.length > 12) {
          scrollbar.style.height = '800px';
        } else if (this.onlineFileList.length > 8) {
          scrollbar.style.height = '500px';
        } else {
          scrollbar.style.height = '300px';
        }
      }
    },


    setclassPlanListScrollbarHeight() {
      const scrollbar = this.$refs.classPlanscrollbar;
      if (scrollbar) {
        if (this.classPlan.length > 12) {
          scrollbar.style.height = '800px';
        } else if (this.classPlan.length > 8) {
          scrollbar.style.height = '500px';
        } else {
          scrollbar.style.height = '300px';
        }
      }
    },

    handleEventElUploadSubt(flileList) {


      this.isShowElupload = false;
      if (flileList && flileList.length > 0) {
          if(this.Uploadtypes === "1" ) {
             this.onlineFileList= [...flileList,...this.onlineFileList]
             this.setonlineFileListScrollbarHeight()
          }
          if(this.Uploadtypes === "2" ) {
             this.offlineFileList = [...flileList,...this.offlineFileList]
             this.setofflineFileListScrollbarHeight()
          }
          if(this.Uploadtypes === "3" ) {
             this.classPlan = [...flileList,...this.classPlan]
             this.setclassPlanListScrollbarHeight()
          }
      }


    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.url }？`);
    },
    downloadFile(name,url) {

      loadingUtils.startLoading()

      fetch(url).then(response => response.blob()).then(blob => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = name
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        setTimeout(() => {
          loadingUtils.endLoading()
          this.$message.success('文件下载成功~')
        }, 1000)

      })

    },
    formatDate(date) {
      const d =  date ? new Date(date) : new Date()
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`
    },
    getFileIconClass(filename) {
      const ext = filename.split('.').pop().toLowerCase();
      switch (ext) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'png';
        case 'pdf':
          return 'pdf';
        case 'ppt':
          return 'ppt';
        case 'doc':
        case 'docx':
          return 'doc';
        case 'xlsx':
        case 'xls':
          return 'xlsx';
        default:
          return 'el-icon-document';
      }
    }
  }
};
</script>

<style scoped>
.diagnosis-report {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.el-card__body {
  padding: 10px;
}

.scrollbar {
  height: 300px;
  overflow-y: auto;
}

.file-icon {
  font-size: 36px;
  color: #409EFF;
}

.el-timeline-item__timestamp {
  color: #909399;
}

.upload-demo {
  margin-bottom: 10px;
}

.report-section {
  margin-bottom: 20px;
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}

@keyframes flash {
  0% {
    opacity: 1;
    color: rgb(22, 145, 221);
  }
  14.2857% {
    opacity: 1;
    color: rgb(132, 29, 236);
  }
  28.5714% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  42.8571% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
  57.1428% {
    opacity: 1;
    color: rgb(88, 200, 14);
  }
  71.4285% {
    opacity: 1;
    color: rgb(135, 172, 111);
  }
  85.7142% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  100% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
}

.flashing-text {
  animation: flash 10s infinite alternate;
}

.two-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
}

.no-click{
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/manager/components/subassembly/diagnosticReport.vue